import { render, staticRenderFns } from "./VopMessagePage.vue?vue&type=template&id=ae187c5c&scoped=true&"
import script from "./VopMessagePage.vue?vue&type=script&lang=js&"
export * from "./VopMessagePage.vue?vue&type=script&lang=js&"
import style0 from "./VopMessagePage.vue?vue&type=style&index=0&id=ae187c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae187c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae187c5c')) {
      api.createRecord('ae187c5c', component.options)
    } else {
      api.reload('ae187c5c', component.options)
    }
    module.hot.accept("./VopMessagePage.vue?vue&type=template&id=ae187c5c&scoped=true&", function () {
      api.rerender('ae187c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monitoring/VopMessagePage.vue"
export default component.exports